var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "demo" }, [
    _c("div", {
      staticClass: "chartBar",
      class: { echartNoData: !_vm.hasFlag },
      attrs: { id: "workSpeed" },
    }),
    _c("div", { staticClass: "changeType", on: { click: _vm.changeType } }, [
      _c("span", { staticClass: "top", class: { activetop: _vm.type == 1 } }),
      _c("span", { staticClass: "down", class: { activedown: _vm.type == 2 } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }